export function onPlayerHit(game) {
  game.cameraRig.shake(0.45);
  game.cameraRig.punchZoom(1.4, 0.24);
  game.cameraRig.recoilLook((Math.random() * 2 - 1) * 0.35, (Math.random() * 2 - 1) * 0.35, 0.2);
  game._flashHit();
  if (game.player.hasFragment('adrenal_lock')) {
    game.timeScale = 0.6;
    game._timeScaleTimer = 0.6;
  }
}

export function onPlayerHitEnemy(game, enemy, projectile = null) {
  const isBoss = !!enemy?.isBoss;
  game.cameraRig.shakeImpactGsap({
    intensity: isBoss ? 5 : 3,
    duration: isBoss ? 0.22 : 0.16,
    dirX: projectile ? projectile.dx : null,
    dirZ: projectile ? projectile.dz : null,
  });
}


